<div class="brochure-div">
    <section id="brochure" class="section brochure">
        <div class="container">
            <div class="row text-align-center">
                <div class="col-md-12">
                    <div class="section-title fadeUp">
                        <h2 class="wow fadeInUp" data-wow-delay=".2s">Download the Brochure</h2>
                        <p class="margin-auto wow fadeInUp" data-wow-delay=".3s">Take a copy of the brochure with you to review and share<!-- Start working with etoro that can provide everything you need to generate awareness, drive traffic, connect. --></p>
                    </div>
                    <div class="btnBox mt-5 wow fadeInUp" data-wow-delay=".4s">
                        <a href="https://backseat-trader.com/pdf/BackseatTrader-brochure.pdf" type="button" class="btn theme-btn animate btn2" target="_blank" rel="noopener noreferrer">Download</a>
                    </div> 
                </div>
            </div>
        </div>
    </section>
</div>
